export const getGardenerDomain = (state) =>
  state.accountservice?.ACCOUNT_SERVICE_LIST?.gardener?.identifiers?.[0]
    ?.regionTag;

export const getGardenerState = (state) =>
  state.accountservice?.ACCOUNT_SERVICE_LIST?.gardener;
